import React from "react"

const Container = ({children, style}) => (
  <div className="container" style={style}>
    {children}
  </div>
)

export default Container
